/**
 * Query key factory. Every cache entry is reachable from here, which is what
 * lets the live-sync hook invalidate precisely (or broadly, when a reconnect
 * cannot be replayed).
 */
export const queryKeys = {
  me: ['me'] as const,
  persons: ['persons'] as const,
  assignments: {
    all: ['assignments'] as const,
    range: (fromSlot: number, toSlot: number) => ['assignments', 'range', fromSlot, toSlot] as const,
    upcoming: ['assignments', 'upcoming'] as const,
  },
  changelog: ['changelog'] as const,
} as const;
